import * as emailValidator from 'email-validator';
export const isValidEmail = (email) => emailValidator.validate(email);
//# sourceMappingURL=email.js.map